//search
export const PAYMENT_SEARCH_START_LOADING = "PAYMENT_SEARCH_START_LOADING";
export const PAYMENT_SEARCH_END_LOADING = "PAYMENT_SEARCH_END_LOADING";
export const PAYMENT_SEARCH_LOADED = "PAYMENT_SEARCH_LOADED";
export const SET_PAYMENT_FILTER = "SET_PAYMENT_FILTER";

//Edit
export const PAYMENT_START_LOADING = "PAYMENT_START_LOADING";
export const PAYMENT_END_LOADING = "PAYMENT_END_LOADING";
export const PAYMENT_LOADED = "PAYMENT_LOADED";